const REQUEST_TYPE = "ARGEVIO_VIO_BRIDGE_REQUEST";
const SECURE_REQUEST_TYPE = "ARGEVIO_VIO_BRIDGE_SECURE_REQUEST_V110";
const RESPONSE_TYPE = "ARGEVIO_VIO_BRIDGE_RESPONSE";
const MINIMUM_ACTION_BRIDGE_VERSION = "0.11.11";

const compareBridgeVersions = (left, right) => {
  const leftParts = String(left || "0").split(".").map(Number);
  const rightParts = String(right || "0").split(".").map(Number);
  for (let index = 0; index < Math.max(leftParts.length, rightParts.length); index += 1) {
    const difference = (leftParts[index] || 0) - (rightParts[index] || 0);
    if (difference) return difference;
  }
  return 0;
};

const requestBridge = (action, payload = {}, timeoutMs = 45000) => new Promise((resolve, reject) => {
  const requestId = `vio-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  let timer;
  let settleTimer;
  let bestPingResult = null;

  const cleanup = () => {
    window.removeEventListener("message", onMessage);
    window.clearTimeout(timer);
    window.clearTimeout(settleTimer);
  };

  const onMessage = (event) => {
    if (event.source !== window || event.data?.type !== RESPONSE_TYPE || event.data?.requestId !== requestId) return;
    const responseVersion = event.data.bridgeVersion || event.data.result?.version || "";
    if (action === "ping") {
      if (event.data.ok) {
        if (!bestPingResult || compareBridgeVersions(responseVersion, bestPingResult.version) > 0) {
          bestPingResult = { ...(event.data.result || {}), version: responseVersion };
        }
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(() => {
          cleanup();
          resolve(bestPingResult);
        }, 350);
      }
      return;
    }
    if (action !== "ping" && compareBridgeVersions(responseVersion, MINIMUM_ACTION_BRIDGE_VERSION) < 0) {
      return;
    }
    cleanup();
    if (event.data.ok) resolve(event.data.result);
    else reject(new Error(event.data.error || "Vio Köprü yanıt vermedi."));
  };

  window.addEventListener("message", onMessage);
  timer = window.setTimeout(() => {
    cleanup();
    reject(new Error(action === "ping"
      ? "Vio Köprü bulunamadı."
      : "ARGEPORTAL köprü işlemi zaman aşımına uğradı. Oturumun etkin olduğunu kontrol edin."));
  }, timeoutMs);
  window.postMessage({
    type: action === "ping" ? REQUEST_TYPE : SECURE_REQUEST_TYPE,
    requestId,
    action,
    payload,
    minimumBridgeVersion: MINIMUM_ACTION_BRIDGE_VERSION
  }, window.location.origin);
});

export const detectVioPortalBridge = () => requestBridge("ping", {}, 1800);

export const collectVioPortalSnapshot = ({ portalUrl, periodKey, scope, login }) =>
  requestBridge("collect", { portalUrl, periodKey, scope, login }, scope === "dgs" ? 45000 : 130000);

export const prepareVioPortalJob = ({ portalUrl, job, login }) =>
  requestBridge("prepare", { portalUrl, job, login }, 130000);

export const verifyVioPortalJob = ({ portalUrl, job, login }) =>
  requestBridge("verify", { portalUrl, job, login }, 35000);
